export type PathAvailability = 'Availability' | 'Search' | 'LowPrices';

export const AVAILABILITY_PROVIDER_NAME = 'AvailabilityDefaultService';

export const PathAvailabilityManager: Record<PathAvailability, PathAvailability> = {
  Availability: 'Availability',
  Search: 'Search',
  LowPrices: 'LowPrices'
};
